export default __webpack_public_path__ + "static/media/plusWhite.c6223119.svg";